import { render, staticRenderFns } from "./developUser.vue?vue&type=template&id=22ee6905&scoped=true&"
import script from "./developUser.vue?vue&type=script&lang=js&"
export * from "./developUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee6905",
  null
  
)

export default component.exports